import { useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Undo2, ShieldAlert } from "lucide-react";
import { migApi, errMsg } from "./lib";

// Super Admin only. Always asks NEEC Service for eligibility first; never bypasses backend safety.
export function RollbackButton({ cid, batch, onDone }) {
  const [elig, setElig] = useState(null);
  const [busy, setBusy] = useState(false);
  const check = async () => {
    setBusy(true);
    try { setElig(await migApi.eligibility(cid, batch.id)); } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  const run = async () => {
    const rc = elig?.record_counts || {};
    const what = Object.entries(rc).map(([k, v]) => `${v} ${k}`).join(", ") || "all imported records";
    if (!window.confirm(`Roll back "${batch.filename}"?\n\nThis removes ${what} created by this batch from NEEC Service. This cannot be undone.`)) return;
    setBusy(true);
    try { const r = await migApi.rollback(cid, batch.id); toast.success(`Rolled back: removed ${Object.entries(r.rollback?.removed || {}).map(([k, v]) => `${v} ${k}`).join(", ") || "records"}`); onDone?.(r); }
    catch (e) { toast.error(errMsg(e)); setElig(null); } finally { setBusy(false); }
  };
  if (batch.status !== "committed") return null;
  if (!elig) return <Button size="sm" variant="outline" className="h-7 text-xs" disabled={busy} onClick={check} data-testid={`mig-rollback-check-${batch.id}`}><Undo2 className="w-3 h-3 mr-1" /> Rollback</Button>;
  if (!elig.eligible) return (
    <div className="text-[11px] text-rose-700 bg-rose-500/10 rounded-md px-2 py-1 flex items-start gap-1" data-testid={`mig-rollback-blocked-${batch.id}`}>
      <ShieldAlert className="w-3.5 h-3.5 shrink-0 mt-0.5" /><span><b>Rollback blocked:</b> {(elig.reasons || []).join(" ") || "NEEC Service did not allow rollback."}</span>
    </div>
  );
  return <Button size="sm" className="h-7 text-xs bg-rose-600 hover:bg-rose-700 text-white" disabled={busy} onClick={run} data-testid={`mig-rollback-confirm-${batch.id}`}><Undo2 className="w-3 h-3 mr-1" /> Confirm rollback</Button>;
}
